module.exports = __webpack_public_path__ + "img/malla ondulada 2.4bc26fc0.jpg";